import CalendarioVacunacion from "./CalendarioVacunacion";
export default CalendarioVacunacion;